module.exports = __webpack_public_path__ + "../assets/left-arrow2.png";